import { AType, summon } from "@silversea-ssc/functional-support"
import * as F from "fp-ts/function"
import * as ORD from "fp-ts/Ord"
import * as EQ from "fp-ts/Eq"
import * as S from "fp-ts/string"
import * as N from "fp-ts/number"

const airClassKeys = { Economy: null, EconomyPlus: null, Business: null, First: null }
export const _AirClass = summon((F) => F.keysOf(airClassKeys))
export type AirClass = AType<typeof _AirClass>
export const AirClass = /* @__PURE__ */ Object.assign(_AirClass, {
    Ord: <ORD.Ord<AirClass>>S.Ord,
})

const airFarePriority: { [key in AirFare]: number } = {
    CruiseOnly: 10,
    Economy: 20,
    EconomyPlus: 40,
    Business: 60,
    First: 80,
}

const airFareKeys = { ...airClassKeys, CruiseOnly: null }
const _AirFare = summon((F) => F.keysOf(airFareKeys))
export type AirFare = AType<typeof _AirFare>
export const AirFare = /* @__PURE__ */ Object.assign(_AirFare, {
    PriorityOrd: F.pipe(
        N.Ord,
        ORD.reverse,
        ORD.contramap((x: AirFare) => airFarePriority[x]),
    ),
    Eq: F.pipe(
        S.Eq,
        EQ.contramap((x: AirFare) => x),
    ),
    isUpgrade: (base: AirFare, maybeUpgrade: AirFare): boolean => AirFare.PriorityOrd.compare(maybeUpgrade, base) < 0,
})

const requestAirFareKeys = { ...airFareKeys, NotAvailable: null }
export const RequestAirFare = summon((F) => F.keysOf(requestAirFareKeys))
export type RequestAirFare = AType<typeof RequestAirFare>
